/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ObjectStore } from "./ObjectStore";
import {
  ObjectStoreFromJSON,
  ObjectStoreFromJSONTyped,
  ObjectStoreToJSON,
} from "./ObjectStore";

export interface ObjectStoreDataResponse {
  data: ObjectStore;
}

export function ObjectStoreDataResponseFromJSON(
  json: any,
): ObjectStoreDataResponse {
  return ObjectStoreDataResponseFromJSONTyped(json);
}

export function ObjectStoreDataResponseFromJSONTyped(
  json: any,
): ObjectStoreDataResponse {
  if (json == null) {
    return json;
  }

  return {
    data: ObjectStoreFromJSON(json["data"]),
  };
}

export function ObjectStoreDataResponseToJSON(
  value: ObjectStoreDataResponse | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: ObjectStoreToJSON(value.data),
  };
}
